import queryString from 'query-string';

import type { GlossaryProp } from '~/domains/cms/enums/glossary.enum';
import type { LeagueAlias } from '~/domains/common/enums/league-alias.enum';
import { type GlossaryResponse } from '~/pages/api/gamecenter/glossary/[league]/[prop]';
import { type AlternatesContent } from '~/pages/api/gamecenter/alternates/[league]';

import { nextApiServiceInstance, nextApiAuthServiceInstance } from './nextApi.instance';

export const getLatestAppVersion = async () => {
  const response = await nextApiServiceInstance.get('/version');

  return response.data;
};

type GetAutocompleteProps = {
  input?: string;
  country?: string;
  placeId?: string;
  sessionToken: string;
};

export const getAutocomplete = async ({
  input,
  country,
  placeId,
  sessionToken,
}: GetAutocompleteProps) => {
  const query = queryString.stringify({ input, country, placeId, sessionToken });

  const response = await nextApiAuthServiceInstance.get(`/autocomplete?${query}`);

  return response.data as
    | google.maps.places.AutocompleteResponse
    | { result: google.maps.places.PlaceResult };
};

export const getExchangeSingleUseToken = async ({
  sut,
  webView,
}: {
  sut: string;
  webView: boolean;
}): Promise<string> => {
  const response = await nextApiAuthServiceInstance.post(`/sut/single-use`, {
    sut,
    webView,
  });

  return response.data;
};

export const fetchGlossary = async (
  league: LeagueAlias,
  prop: GlossaryProp
): Promise<GlossaryResponse> => {
  const response = await nextApiAuthServiceInstance.get(`/gamecenter/glossary/${league}/${prop}`);
  return response.data;
};

export const fetchAlternates = async (league: LeagueAlias): Promise<AlternatesContent> => {
  const response = await nextApiAuthServiceInstance.get(`/gamecenter/alternates/${league}`);
  return response.data;
};
